var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("h1", { staticClass: "center", attrs: { id: "pageTitle" } }, [
      _vm._v("Meine Daten"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Meine persönlichen Daten"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body content-center p-3" }, [
            _c(
              "form",
              {
                staticClass: "form-horizontal justify-content-center",
                attrs: { role: "form" },
              },
              [
                _c("fieldset", [
                  _c("div", { staticClass: "row form-group" }, [
                    _c("div", { staticClass: "col col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "firstname" },
                        },
                        [_vm._v("Vorname")]
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userdata.firstname,
                              expression: "userdata.firstname",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "firstname" },
                          domProps: { value: _vm.userdata.firstname },
                          on: {
                            change: function ($event) {
                              return _vm.setDirty()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.userdata,
                                "firstname",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col col-sm-6" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "lastname" },
                        },
                        [_vm._v("Nachname")]
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userdata.lastname,
                              expression: "userdata.lastname",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "lastname" },
                          domProps: { value: _vm.userdata.lastname },
                          on: {
                            change: function ($event) {
                              return _vm.setDirty()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.userdata,
                                "lastname",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10",
                        attrs: { for: "email", placeholder: "E-mail" },
                      },
                      [_vm._v("E-mail")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userdata.email,
                            expression: "userdata.email",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", readonly: "", id: "email" },
                        domProps: { value: _vm.userdata.email },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.userdata, "email", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row mt-4" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10",
                        attrs: { for: "oldPw" },
                      },
                      [
                        _vm._v(
                          "Bisheriges Passwort (das haben wir uns sicherheitshalber\n                  nicht gemerkt)"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userdata.oldPw,
                            expression: "userdata.oldPw",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "oldPw" },
                        domProps: { value: _vm.userdata.oldPw },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.userdata, "oldPw", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10",
                        attrs: { for: "newPw" },
                      },
                      [_vm._v("Neues Passwort")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userdata.newPw,
                            expression: "userdata.newPw",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "newPw" },
                        domProps: { value: _vm.userdata.newPw },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.userdata, "newPw", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label col-sm-10",
                        attrs: { for: "newPwConfirm" },
                      },
                      [_vm._v("Bestätigung neues Passwort")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userdata.newPwConfirm,
                            expression: "userdata.newPwConfirm",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", id: "NewPwConfirm" },
                        domProps: { value: _vm.userdata.newPwConfirm },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.userdata,
                              "newPwConfirm",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center mt-2" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", id: "buttonChangePw" },
                        on: { click: _vm.changePw },
                      },
                      [
                        _vm._v(
                          "\n                  Passwort ändern\n                "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row mt-4" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-12 control-label",
                        attrs: { for: "textinput" },
                      },
                      [_vm._v("Telefonnummer (optional)")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userdata.telephone,
                            expression: "userdata.telephone",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "Telefonnnummer",
                          id: "telephone",
                        },
                        domProps: { value: _vm.userdata.telephone },
                        on: {
                          change: function ($event) {
                            return _vm.setDirty()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.userdata,
                              "telephone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "textinput" },
                        },
                        [_vm._v("Straße und Hausnummer")]
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userdata.street,
                              expression: "userdata.street",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "Strasse" },
                          domProps: { value: _vm.userdata.street },
                          on: {
                            change: function ($event) {
                              return _vm.setDirty()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.userdata,
                                "street",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "textinput" },
                        },
                        [_vm._v("Postleitzahl oder Wohnort")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentZipAndPlace,
                            expression: "currentZipAndPlace",
                          },
                        ],
                        staticClass: "col-sm-12 form-control",
                        attrs: {
                          type: "text",
                          id: "city",
                          list: "selectedCity",
                        },
                        domProps: { value: _vm.currentZipAndPlace },
                        on: {
                          change: function ($event) {
                            _vm.setDirty()
                            _vm.checkIfCityValid()
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.currentZipAndPlace = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "datalist",
                        { attrs: { id: "selectedCity" } },
                        _vm._l(_vm.cityList, function (item) {
                          return _c("option", [
                            _vm._v(
                              "\n                      " +
                                _vm._s(item.plz) +
                                " - " +
                                _vm._s(item.stadt) +
                                "\n                    "
                            ),
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      !_vm.isValidCity && !this.isEmptyCity
                        ? _c(
                            "label",
                            {
                              staticClass: "control-label text-danger",
                              attrs: { id: "invalidCity", for: "textinput" },
                            },
                            [
                              _vm._v(
                                "Die Postleitzahl/Stadt-Kombination ist nicht gültig.\n                    Bitte gib eine gültige Kombination aus der Liste\n                    an."
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "m-2 btn btn-outline-primary",
                            attrs: { type: "button", id: "btnResetCity" },
                            on: {
                              click: function ($event) {
                                _vm.setDirty()
                                _vm.resetCity()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                      Ort/PLZ leeren\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-outline-primary",
                              attrs: { to: "/signedin" },
                            },
                            [
                              _vm._v(
                                "\n                      Zurück\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                id: "updatePersonalData",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.updatePersonalData()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                      Speichern\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row mt-3" }, [
                    _c("div", { staticClass: "col col-sm-12" }, [
                      _c("div", { staticClass: "text-center mt-2" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-danger",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.activateDeleteBlock()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                      Meinen Account löschen\n                    "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isDelBlockActive
                        ? _c("div", [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userdata.deleteActiveUser,
                                    expression: "userdata.deleteActiveUser",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "DeleteConfirmText",
                                },
                                domProps: {
                                  value: _vm.userdata.deleteActiveUser,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userdata,
                                      "deleteActiveUser",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-center mt-2" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.keepCurrentUser()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Behalten\n                      "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delCurrentUser()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Löschen\n                      "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row align-items-center mt-3" }, [_vm._v(" ")]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "control-label", attrs: { for: "DeleteConfirmText" } },
      [
        _vm._v("Bitte gib "),
        _c("span", { staticStyle: { color: "#ff0000" } }, [_vm._v("JA ")]),
        _vm._v(
          " ein,\n                      um den Account wirklich zu löschen"
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }